<template>
  <layout-main-inner title="采购产品">
    <layout-card-wrap v-loading="loading"
                      hasHeaderSlot>
      <template slot="title">
        <el-button type="primary"
                   @click="addItem">新增采购产品</el-button>
      </template>
      <template slot="form">
        <el-input style="margin-left:10px;"
                  clearable=""
                  placeholder="请输入产品名称"
                  v-model="config.tagProductName">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table border
                :data="list">
        <el-table-column label="产品名称"
                         min-width="160"
                         prop="tagProductName"></el-table-column>
        <el-table-column label="产品规格"
                         min-width="100"
                         prop="size"></el-table-column>
        <el-table-column label="产品材质"
                         min-width="100"
                         prop="materialQuality"></el-table-column>
        <el-table-column label="产品备注"
                         min-width="320"
                         prop="tagProductNameRemark"></el-table-column>
        <el-table-column label="操作"
                         width="160">
          <template slot-scope="{row}">
            <el-button type="text"
                       @click="editItem(row)">编辑</el-button>
            <el-button type="text"
                       @click="deleteItem(row)">删除</el-button>
            <purchase-product-price-popover :row="row" />
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
    <purchase-product-edit-modal ref="modal"
                                 @fetch="fetchList" />
  </layout-main-inner>
</template>

<script>
// import HscodeEditModal from './busi/hscode-edit-modal.vue'
import Purchase from '../../service/purchase'
import PurchaseProductEditModal from './busi/purchase-product-edit-modal.vue'
import PurchaseProductPricePopover from './busi/purchase-product-price-popover.vue'
export default {
  name: 'purchase-product',
  components: { PurchaseProductEditModal, PurchaseProductPricePopover },
  data () {
    return {
      loading: false,
      config: { pageNum: 1, pageSize: 10, tagProductName: '' },
      list: [],
      total: 0
    }
  },
  methods: {
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      Purchase.gettagproducts({ ...this.config })
        .then(res => {
          const { result, message, total, records } = res.data
          this.loading = false
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    addItem () {
      this.$refs.modal.init()
    },
    editItem (row) {
      const { id, tagProductName, size, materialQuality, tagProductNameRemark, stepPrices } = row
      this.$refs.modal.init({ id, tagProductName, size, materialQuality, tagProductNameRemark, stepPrices: JSON.parse(JSON.stringify(stepPrices)) })
    },
    deleteItem (row) {
      this.$confirm('此操作将删除该采购产品, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Purchase.deletetagproduct({ id: row.id })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
